/**
 * A link that scrolls to the respective FAQ section (.section-faq).
 * Matched by index. E.g. first link scrolls to first section, etc.
 *
 * Usage:
 *  <faq-scroll-link>
      <a href="">Scroll</a>
    </faq-scroll-link>
 */
if (!customElements.get('faq-scroll-link')) {
  class FaqScrollLink extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.anchor = this.querySelector('a');

      this.attachEvents();
    }

    attachEvents = () => {
      const links = document.querySelectorAll('faq-scroll-link');
      const index = Array.from(links).indexOf(this);
      const matchingFaqSectionId =
        document.querySelectorAll('.section-faq')[index]
        ?.closest('.shopify-section')
        ?.getAttribute('id');
      this.anchor?.setAttribute('href', `#${matchingFaqSectionId}`);
    }
  }
  customElements.define('faq-scroll-link', FaqScrollLink);
}
